import React from "react";

const BlueprintLogoSmall: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="123"
    height="18"
    viewBox="0 0 123 18"
    fill="none"
    {...props}
  >
    <path
      d="M5.91611 6.94314C5.97648 6.94314 6.01673 6.94314 6.05697 6.94314C6.78139 6.90301 7.16373 6.68227 7.46557 6.3612C7.76741 6.02007 7.94852 5.51839 7.94852 4.99666C7.94852 4.47492 7.76741 3.97324 7.46557 3.63211C7.14361 3.29097 6.74115 3.05017 5.91611 3.05017H3.03855V6.94314H5.91611ZM5.91611 0.0200666C7.48569 0.0200666 8.83392 0.642141 9.71933 1.58528C10.5846 2.54849 10.9871 3.79264 10.9871 4.99666C10.9871 6.1806 10.6047 7.36455 9.7797 8.30769C10.9468 9.31104 11.5908 10.7358 11.5908 12.1605C11.5908 14.7692 9.37724 17.398 5.91611 17.398L0.0603685 17.3779H0.0402457L0 0.0200666H5.91611ZM6.0771 9.97324C6.01673 9.97324 5.97648 9.97324 5.91611 9.97324H3.03855V14.3679H5.91611C8.00889 14.3679 8.5522 13.2642 8.5522 12.1605C8.5522 11.0769 8.02901 10.0134 6.0771 9.97324Z"
      fill="black"
    />
    <path d="M13.6288 0H16.6674V14.3478H26.5879V17.3779H13.6288V0Z" fill="black" />
    <path
      d="M27.631 0.0802665H30.6695V9.87291C30.6695 13.6054 32.8629 14.9699 35.0563 14.9699C37.2497 14.9699 39.4431 13.6054 39.4431 9.87291V0.0802665H42.4817V9.87291C42.4817 14.9498 38.7589 18 35.0563 18C31.3336 18 27.631 14.9498 27.631 9.87291V0.0802665Z"
      fill="black"
    />
    <path
      d="M53.7879 5.9398V8.9699C51.4737 8.9699 50.5078 9.37124 49.3005 9.85284C48.6968 10.1137 47.9925 10.3946 47.1674 10.6154V14.3478H55.3977V17.3779H44.1289V0H54.9952V3.05017H47.1674V7.44482C47.4693 7.32441 47.7912 7.20401 48.1535 7.04348C49.4011 6.54181 51.0512 5.9398 53.7879 5.9398Z"
      fill="black"
    />
    <path
      d="M57.0503 0H62.9664C66.7092 0 69.0233 2.86957 69.0233 5.699C69.0233 8.50836 66.7092 11.3779 62.9664 11.3779H60.0888V17.3779H57.0503V0ZM60.0888 8.34783H62.9664C65.3006 8.34783 65.9848 7.04348 65.9848 5.699C65.9848 4.33445 65.3006 3.05017 62.9664 3.05017H60.0888V8.34783Z"
      fill="black"
    />
    <path
      d="M70.6791 0H76.5952C80.338 0 82.6522 2.86957 82.6522 5.699C82.6522 7.62542 81.5655 9.59197 79.6539 10.6355C79.9557 11.0769 80.2173 11.5184 80.499 11.9398C81.0222 12.7625 81.5655 13.485 82.129 13.9465C82.6723 14.408 83.1955 14.6689 84.0608 14.6689V17.699C82.4912 17.699 81.143 17.097 80.1771 16.2742C79.191 15.4716 78.527 14.4883 77.9434 13.5853C77.3599 12.7023 76.8769 11.8997 76.4543 11.4381C76.4342 11.4181 76.4342 11.398 76.4141 11.3779H73.7176V17.3779H70.6791V0ZM73.7176 8.34783H76.5952C78.9294 8.34783 79.6136 7.04348 79.6136 5.699C79.6136 4.33445 78.9294 3.05017 76.5952 3.05017H73.7176V8.34783Z"
      fill="black"
    />
    <path d="M85.6049 0H88.6434V17.3779H85.6049V0Z" fill="black" />
    <path
      d="M90.6854 0H93.724C93.724 1.78595 94.3478 3.01003 95.4344 4.21405C96.521 5.39799 98.0906 6.48161 99.7809 7.58528C101.25 8.56856 102.819 9.55184 104.168 10.8361V0H107.206V17.3779H104.168C104.168 15.7324 103.544 14.5886 102.457 13.4448C101.371 12.2809 99.7809 11.2174 98.0906 10.1137C96.6217 9.13043 95.0521 8.10702 93.724 6.80268V17.3779H90.6854V0Z"
      fill="black"
    />
    <path d="M108.854 0H123V3.05017H117.446V17.3779H114.408V3.05017H108.854V0Z" fill="black" />
  </svg>
);

export default BlueprintLogoSmall;
